import './translations';
import { Alert } from './Alert/Alert';

const dsp = (global.dsp = global.dsp || {});

dsp.alert = (options = {}) => {
  let alertClass = new Alert(options);

  if (alertClass.type === 'normal') {
    alertClass.show();
  } else if (alertClass.type === 'confirm') {
    return alertClass.showConfirmation();
  }
};
